"use client"

import { usePathname } from "next/navigation"
import { Header } from "@/components/header"

const PUBLIC_HEADER_ROUTES = ["/", "/blog", "/yearly-reflect"]

export function PublicHeader() {
  const pathname = usePathname()
  const shouldShowHeader =
    PUBLIC_HEADER_ROUTES.includes(pathname) || pathname.startsWith("/blog/")

  if (!shouldShowHeader) {
    return null
  }

  return <Header />
}
